<template>
  <ModalContainer class="basic-modal mission-achieved-modal">
    <Card class="modal-content mx-auto">
      <div class="mdl-card__title typography--color-primary typography--font-weight-bold text-center mission-achieved-modal__header">
        미션 완료!
      </div>

      <div class="mission-achieved-modal__body">
        <!-- Single mission -->
        <div class="mission-achieved-modal__body--single"
             v-for="mission in achievedMissions"
             v-bind:key="mission.id"
             v-if="achievedMissions.length === 1">
          <div class="achieved-mission__image text-center">
            <img v-bind:src="mission.image_url">
          </div>

          <div class="typography--color-primary achieved-mission__title text-center">
            {{ mission.name }}
          </div>

          <div class="typography--color-secondary achieved-mission__description text-center">
            + {{ mission.description }}
          </div>
        </div>

        <!-- Multiple missions -->
        <div class="mission-achieved-modal__body--multiple" v-if="achievedMissions.length > 1">
          <div class="achieved-mission"
               v-for="mission in achievedMissions"
               v-bind:key="mission.id">
            <div class="achieved-mission__image">
              <img v-bind:src="mission.image_url">
            </div>

            <div class="achieved-mission__info">
              <div class="typography--color-primary achieved-mission__title">
                {{ mission.name }}
              </div>

              <div class="typography--color-secondary achieved-mission__description">
                + {{ mission.description }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mdl-card__actions mission-achieved-modal__actions">
        <div class="mission-achieved-modal__btn" v-if="!hideGoToBadges">
          <button class="mdl-button mdl-button--primary mdl-js-button mdl-js-ripple-effect w-100"
                  v-on:click="goToBadgesPage()"
                  v-mdl>
            미션 현황 보기
          </button>
        </div>

        <div class="mission-achieved-modal__btn" v-bind:class="{ 'mx-auto': hideGoToBadges, 'float-none': hideGoToBadges }">
          <button class="mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect w-100"
                  v-on:click="clearNewlyAchievedMissions()"
                  v-mdl>
            확인
          </button>
        </div>
      </div>
    </Card>
  </ModalContainer>
</template>

<script>
  import { mapActions } from 'vuex';

  export default {
    name: 'mission-achieved-modal',

    props: {
      achievedMissions: {
        type: Array,
        default() {
          return [];
        },
      },
      hideGoToBadges: {
        type: Boolean,
        default: false,
      },
    },

    methods: {
      ...mapActions([
        'clearNewlyAchievedMissions',
      ]),

      goToBadgesPage() {
        this.clearNewlyAchievedMissions()
          .then(() => (
            this.$router.push('/badges')
          ));
      },
    },
  };
</script>

<style lang="scss">
  .mission-achieved-modal {
    .modal-content {
      width: 100%;
      max-width: 330px;

      @media (min-width: 480px) {
        max-width: 460px;
      }
    }

    .mission-achieved-modal__header {
      font-size: 18px;
      line-height: 1.28;
      display: block;
      padding-top: 30px;
      padding-bottom: 22px;

      @media (min-width: 480px) {
        padding-top: 32px;
        padding-bottom: 30px;
      }
    }

    .mission-achieved-modal__body {
      padding-left: 16px;
      padding-right: 16px;
    }

    .achieved-mission {
      display: table;
      table-layout: fixed;
      width: 100%;
      padding-top: 10px;
      padding-bottom: 10px;

      .achieved-mission__image {
        display: table-cell;
        width: 42px;
      }

      .achieved-mission__info {
        display: table-cell;
        vertical-align: middle;
        padding-left: 20px;

        @media (min-width: 480px) {
          padding-left: 16px;
        }
      }
    }

    .achieved-mission__image>img {
      max-width: 42px;
    }

    .achieved-mission__title {
      font-size: 14px;
      font-weight: bold;
      line-height: 1.64;
      padding-bottom: 2px;

      @media (min-width: 480px) {
        font-size: 16px;
        font-weight: 600;
        line-height: 1.44;
      }
    }

    .achieved-mission__description {
      font-size: 14px;
      line-height: 1.64;
    }

    .mission-achieved-modal__body--single {
      padding-bottom: 4px;

      @media (min-width: 480px) {
        padding-top: 8px;
      }

      .achieved-mission__title {
        padding-top: 12px;

        @media (min-width: 480px) {
          padding-top: 10px;
        }
      }
    }

    .mission-achieved-modal__body--multiple {
      padding: 2px 10px 0;

      @media (min-width: 480px) {
        max-width: 328px;
        margin-left: auto;
        margin-right: auto;
      }
    }

    .mission-achieved-modal__actions {
      padding: 36px 10px 20px;

      @media (min-width: 480px) {
        padding-top: 42px;
        padding-bottom: 40px;
        max-width: 332px;
        margin-left: auto;
        margin-right: auto;
      }

      &:before,
      &:after {
        display: table;
        content: " ";
        clear: both;
      }
    }

    .mission-achieved-modal__btn {
      float: left;
      width: 50%;
      padding-left: 6px;
      padding-right: 6px;

      @media (min-width: 480px) {
        padding-left: 8px;
        padding-right: 8px;
      }

      .mdl-button--primary {
        border: solid 1px #00c896;
        border-radius: 4px;
        height: 40px;
      }

      .mdl-button--colored {
        color: #fff;
        border-radius: 4px;
        height: 40px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// MissionAchievedModal.vue?56fe43ee